"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientError = void 0;
class ClientError extends Error {
    constructor(data, httpStatus) {
        if (typeof data === 'string') {
            super(data);
            this.httpStatus = httpStatus ? httpStatus : 0;
        }
        else {
            super(data === null || data === void 0 ? void 0 : data.message);
            this.errorCode = data === null || data === void 0 ? void 0 : data.error;
            this.details = data;
            this.httpStatus = httpStatus ? httpStatus : data === null || data === void 0 ? void 0 : data.statusCode;
        }
    }
}
exports.ClientError = ClientError;
